import React from 'react';
import dict from '../../dictionary';
import { ButtonGroup } from '../buttonGroup/buttonGroup';

import './ChartMetric.scss';

const viewModes = {
  hospitalized: 'hospitalized',
  inICU: 'inICU',
  bedsTaken: 'bedsTaken',
};

/**7
 * Radio button toggle between deaths, not resolved, resolved
 */
const ChartMetric = (props) => {
  // "translate" between metric and view mode.
  // cannot change phu keys to match view mode because many other components use them
  const metricToViewMode = (metric) => {
    switch (metric) {
      case dict.hospitalized:
        return viewModes.hospitalized;
      case dict.inICU:
        return viewModes.inICU;
      case dict.bedsTaken:
        return viewModes.bedsTaken;
      default:
        return 'failed';
    }
  };

  const viewModeToMetric = (metric) => {
    switch (metric) {
      case viewModes.hospitalized:
        return dict.hospitalized;
      case viewModes.inICU:
        return dict.inICU;
      case viewModes.bedsTaken:
        return dict.bedsTaken;
      default:
        return 'failed';
    }
  };

  return (
    <div className="chart-metric">
      <ButtonGroup
        selected={metricToViewMode(props.metric)}
        viewModes={viewModes}
        lang={props.lang}
        handleOnClick={(item) => {
          props.setMetric(viewModeToMetric(item));
        }}
      />
    </div>
  );
};

export default ChartMetric;
